namespace RioERP.Carts {
    export namespace CartProductsService {
        export const baseUrl = 'Carts/CartProducts';

        export declare function Create(request: Serenity.SaveRequest<CartProductsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CartProductsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CartProductsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CartProductsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AddToCart(request: AddToCartRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AddCartProduct(request: CalculateCartProductRequest, onSuccess?: (response: Serenity.RetrieveResponse<CartProductsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Carts/CartProducts/Create",
            Update = "Carts/CartProducts/Update",
            Delete = "Carts/CartProducts/Delete",
            Retrieve = "Carts/CartProducts/Retrieve",
            List = "Carts/CartProducts/List",
            AddToCart = "Carts/CartProducts/AddToCart",
            AddCartProduct = "Carts/CartProducts/AddCartProduct"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'AddToCart', 
            'AddCartProduct'
        ].forEach(x => {
            (<any>CartProductsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
